import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { schoolActions } from "../../store/school";

import styled from "styled-components";
import { Normalize } from "@smooth-ui/core-sc";
import { Flex, Image, Text } from "rebass";
import { Circle } from "styled-spinkit";
import logo from "../../resources/img/logo-new.png";
import LoginForm from "../Forms/LoginForm";
import "./Splash.css";

const SplashContainer = styled(Flex)`
  width: 100vw;
  height: 100vh;
  @media screen and (max-width: 768px) {
    justify-content: unset;
    padding-top: 5.5rem;
  }
  font-family: lato, sans-serif;
  font-weight: 700;
  font-style: normal;
  .auth-logo {
    height: 17.3vw;
    margin-top: -2rem;
  }

  @media screen and (max-width: 1800px) {
    .auth-logo {
      height: 18vw;
    }
  }
  @media screen and (max-width: 1420px) {
    .auth-logo {
      height: 19vw;
    }
  }
  @media screen and (max-width: 1376px) {
    .auth-logo {
      height: 20vw;
    }
  }
  @media screen and (max-width: 1024px) {
    .auth-logo {
      height: 23vw;
    }
  }
  @media screen and (max-width: 950px) {
    .auth-logo {
      height: 25vw;
    }
  }
  @media screen and (max-width: 768px) {
    .auth-logo {
      height: 14.5rem;
    }
  }
`;

class Splash extends Component {
  state = {
    navigator: false,
  };

  componentDidMount() {
    // this.registerPushNotifications()
  }

  registerPushNotifications = async () => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", async () => {
        const registration = await navigator.serviceWorker.register(
          "../../../firebase-messaging-sw.js",
          {
            updateViaCache: "none",
          }
        );
        if (this.props.firebase.messaging) {
          this.props.firebase.messaging.useServiceWorker(registration);
        }
      });
    }
  };

  render() {
    if (localStorage.getItem("uid")) {
      return <Redirect to={"/app/home"} />;
    }
    const { profile, updateSchool, school } = this.props;
    return (
      <SplashContainer
        m={0}
        p={0}
        bg="#121212"
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <Normalize />
        <Flex justifyContent={"center"} width={1}>
          <Image src={logo} className="auth-logo" />
          {this.state.navigator && (
            <Flex justifyContent={"center"} flexDirection={"column"}>
              <Circle />
              <Text>Navigator Test</Text>
            </Flex>
          )}
        </Flex>
        <LoginForm
          profile={profile}
          school={school}
          updateSchool={updateSchool}
        />
      </SplashContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  // search: sc.refreshSearch(state.search)
});

const mapDispatchToProps = (dispatch) => ({
  updateSchool: (data) => {
    dispatch(schoolActions.updateSchoolInfo(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Splash);
